import { SiteProvider } from '@/hooks/use-site'
import { Toaster } from '@blogging/ui'
import { Outlet } from 'react-router-dom'

export function SiteLayout() {
  return (
    <SiteProvider>
      <main role="main" className="min-h-screen bg-background">
        <Outlet />
      </main>
      <Toaster />
    </SiteProvider>
  )
}
